/**
 * Sync The 1 card number onto the cart as attributes[1_card_number]
 * so link-based checkout still carries the order attribute.
 */
(function () {
  'use strict';

  function syncOneCardAttribute() {
    var node = document.querySelector('[data-jsc-one-card-sync]');
    if (!node) return;

    var nextValue = node.getAttribute('data-value');
    var currentValue = node.getAttribute('data-cart-current') || '';

    if (nextValue == null) return;
    if (String(nextValue).trim() === String(currentValue).trim()) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root.replace(/\/?$/, '/') + 'cart/update.js';

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          '1_card_number': nextValue
        }
      })
    })
      .then(function (response) {
        if (!response.ok) return;
        node.setAttribute('data-cart-current', nextValue);
        var inputs = document.querySelectorAll('input[name="attributes[1_card_number]"]');
        Array.prototype.forEach.call(inputs, function (input) {
          input.value = nextValue;
        });
      })
      .catch(function () {
        // Best-effort; checkout may still work if attribute was set earlier.
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncOneCardAttribute);
  } else {
    syncOneCardAttribute();
  }

  document.addEventListener('cart-drawer:open', syncOneCardAttribute);
  document.addEventListener('theme:cart-drawer:open', syncOneCardAttribute);
})();
